const CommunityImpactSection = () => {
  const impacts = [
    {
      icon: 'ri-team-line',
      title: 'Your Team',
      description: 'Our goal is stability, not slash-and-burn. We keep key people in place and look for ways to grow roles as the business grows.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Your Customers',
      description: 'We protect the way you take care of customers and avoid sudden changes that break the trust you\'ve earned over years.'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Your Reputation',
      description: 'We\'re mindful that your name is still on the line locally. We work to preserve the culture and standards that reflect back on you.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-playfair text-4xl font-bold text-navy mb-6">
              How We Treat What You've Built
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              When we buy a business, we're not looking for a quick flip. We're stepping into the responsibility of caring for your people, your customers, and your reputation.
            </p>
            
            <div className="space-y-6">
              {impacts.map((impact, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#C9A227] rounded-lg flex-shrink-0">
                    <i className={`${impact.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-navy mb-2">{impact.title}</h3>
                    <p className="text-gray-600">{impact.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src="https://static.readdy.ai/image/2a3205e7e8ef8b3d476f9ddb9e8c5218/64a5cbdbae7dad6572fd37409d6175cf.png"
              alt="Thriving small town business community"
              className="rounded-lg shadow-lg w-full h-96 object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/20 to-transparent rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunityImpactSection;
